//3rd Party Components
import React from 'react';
import PropTypes from 'prop-types';
import AUpageAlert from '@gov.au/page-alerts';

const PageAlert = ({ level, title, message }) => {

    const generateContent = () => {
        if (message && message !== '') {
            return (<p dangerouslySetInnerHTML={{__html: message}}></p>)
        }
    }

    return (
        level &&
        <AUpageAlert
            as={level}>
            <h3>{title}</h3>
            {generateContent()}
        </AUpageAlert>
    );
}

PageAlert.propTypes = {
    level: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    message: PropTypes.string
};

export default PageAlert;
